module.exports = __webpack_public_path__ + "media/images/icon__facebook@3x-dde32676efbab0a1d23dd2c4483d74ec.png";